export const devConfig = {
	// Should be the port react is listening on not Express port.
	/**
	 * !!!!!!DO NOT CHANGE THIS ----- if you are using 3001 you are not testing this correctly. it should be 3000.
	 *
	 * Try and understand who is (or should be listening) on 3000. CLUE: checkout this project' /bin/www file
	 *
	 */
	APIURI: '', // If server is node server. DO NOT CHANGE!!!!!!
	serverURI: '', // If server is node server. DO NOT CHANGE!!!!!!
	//
	// APIURI: 'https://demo.idyaflow.com', // If server is react server
	// serverURI: 'https://demo.idyaflow.com',

	// APIURI: 'http://app.sportsgeartrade.ca', // If server is react server
	// serverURI: 'http://app.sportsgeartrade.ca',

	// HOMEURL: 'http://www.sportsgeartrade.ca',
	HOMEURL: 'http://demo.idyaflow.com',

	googleAPIKey: 'AIzaSyAmxC2tFegGDusGHua0uL1PPi7Tyqn3e-I',
	mapCenter: { lat: 53.5444, lng: -113.4909 },

};
